// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { cloneElement, isValidElement } from 'react';
import classNames from 'classnames';
import Label from '../Label';
import { jsx as _jsx } from "react/jsx-runtime";
const TabLabel = _ref => {
  let {
    label,
    tabMode,
    baseClassName
  } = _ref;
  if (typeof label === 'string') {
    return /*#__PURE__*/_jsx(Label, {
      className: `${baseClassName}__${tabMode}-label`,
      intent: "danger",
      children: label
    });
  }
  if (/*#__PURE__*/isValidElement(label)) {
    return /*#__PURE__*/cloneElement(label, {
      className: classNames(`${baseClassName}__${tabMode}-label`, label.props.className)
    });
  }
  return null;
};
export default TabLabel;